<template>
  <div :class="componentClasses">
    <div v-if="carData">
      <p class="car-comparison-grid-data__title" v-text="dataPoint.label.value" />
      <p class="car-comparison-grid-data__value" v-html="getDataValue({ carData, dataPoint })" />
    </div>
    <div v-else></div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  dataPoint: {
    label: {
      value: string;
    };
  };
  carData: any;
  index: number;
  getDataValue: ({ carData, dataPoint }: DataValueTypes) => string | undefined;
}>();

type DataValueTypes = {
  carData: any;
  dataPoint: any;
};

// Computed values
const componentClasses = computed(() => {
  return [
    'car-comparison-grid-data',
    {
      'first-item': props.index === 0,
      'border-top-none': props.index > 0,
      'empty-grid': !props.carData,
    },
  ];
});
</script>

<style lang="scss" scoped>
.car-comparison-grid-data {
  border: $racq-border-style;
  padding: 0.75rem;
  min-width: 10rem;
  width: auto;

  &__title {
    font-weight: bold;
    margin-top: 0;
    margin-bottom: 0;
    color: $racq-cool-grey;
  }

  &__value {
    margin: 0;
    color: $racq-cool-grey;
  }

  &.border-top-none {
    border-top: none;
  }

  &.empty-grid {
    background: $racq-pale-blue;
    border-bottom: none;
  }

  &.first-item {
    border-top-right-radius: 0.25rem;
    border-top-left-radius: 0.25rem;
  }

  &.last-item {
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
    border-bottom: 1px solid $racq-pale-blue-border;
    margin-bottom: 0.5rem;
  }
}
</style>
